import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "state";
import { Provider } from "react-redux";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "state/api";
import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";

const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem("userToken") || "";
  operation.setContext({
    headers: {
      Authorization: token,
    },
  });
  return forward(operation);
});

const httpLink = createUploadLink({
  uri: "http://localhost:5002/graphql",
});
/* const httpLink = createUploadLink({
  uri: "https://corpmoqueguabackend.onrender.com/graphql",
}); */

const client = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false,
  }),
  link: authLink.concat(httpLink),


  credentials: "same-origin",
});

const store = configureStore({
  reducer: {
    global: globalReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});
setupListeners(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </Provider>
);
